// extracted by mini-css-extract-plugin
export default {"navigation-desktop":"NavigationDesktop_navigation-desktop__CA-rS","fa-beat":"NavigationDesktop_fa-beat__Z2ZpX"};